/*
 * @Description: 发票维护。
                 工业、服务商、供应商通用
 *               只有工业有客户列表，根据返回数据展示
 * @Date: 2025-06-13 16:53:18
 */
import InvoiceEnterpriseDialog from './invoice-enterprise-dialog.vue';

export default InvoiceEnterpriseDialog;
